import User from "../Models/User/User";

// -- Import only the relevant firebase packages or it complains at you.
import * as firebase from 'firebase/app';
import 'firebase/auth';

class AuthService {
    private _baseUrl: string = null;

    public set baseUrl(val: string) {
        this._baseUrl = val;
    }

    public checkAuthorization(fbAuthToken: string): Promise<firebase.auth.UserCredential> {
        return firebase.auth().signInWithCustomToken(fbAuthToken);

    }

}

export default new AuthService();